<template>
  <!-- user read modal for the paying user grid -->
  <div
    class="modal fade"
    data-keyboard="false"
    data-backdrop="static"
    id="readUserModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
  >
    <div
      class="modal-dialog modal-width"
      role="document"
      v-bind:class="{ 'modal-lg': currentStep == 'step2' }"
    >
      <div class="modal-content">
        <div class="modal-header" style="height: 60px">
          <button
            id="stepeReadModal"
            v-if="currentStep != 'step1'"
            @click="currentStep = 'step1'"
            style="cursor: pointer; background-color: transparent"
            class="btn"
          >
            <em class="fa fa-chevron-left icons icon-chevron"></em>
          </button>
          <h5 class="card-title text-center text-join">Visualizar Usuário</h5>

          <button
            type="button"
            class="close"
            id="closeReadModal"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <read-user
            v-if="currentStep == 'step1'"
            v-bind="ReadUserProps"
            @stepReadUserComplete="stepReadUserComplete"
          ></read-user>
          <read-link-user
            v-if="currentStep == 'step2'"
            v-bind="ReadUserProps"
            @stepReadLinkedPayer="stepReadLinkedPayer"
          ></read-link-user>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import ReadLinkUser from "./ReadLinkUser";
import ReadUser from "./ReadUser";

export default {
  components: { ReadUser, ReadLinkUser },
  name: "ReadModalUser",
  data() {
    return {
      payload: {},
      currentStep: "step1",
    };
  },

  props: ["userId"],

  methods: {
    stepReadUserComplete: function (data) {
      this.payload = data;
      this.currentStep = "step2";
    },

    stepReadLinkedPayer: function (linkedPayer) {
      this.payload.user_payers = linkedPayer;
      this.payload.user_registration_type = "cpf";
      axios.put(`${process.env.API_PBM}/payers/${this.userId}`, this.payload).then(
        (result) => {
          if (result.status === "success") {
            this.$router.push({ name: "RegisteredPayerUser" });
          }
        },
        (error) => {
          console.error(error);
        }
      );
    },
  },
  mounted() {},

  computed: {
    ReadUserProps: function () {
      return { userId: this.userId };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-join {
  color: rgb(100, 95, 95);
  font-size: 20px;
  margin-left: 32%;
}
.form-control:disabled {
  background-color: #e9ecef;
  opacity: 1;
}

.form-control {
  color: gray;
}

.input-length {
  width: 80%;
  margin: 0 auto;
}

.edit-button {
  background-color: #ced4da;
  height: 100%;
  border: none;
  border-radius: 2px;
}
label {
  display: inline-block;
  font-size: 17px;
  color: rgb(100, 95, 95);
}
.icon-chevron {
  font-size: 20px;
  color: rgb(100, 95, 95);
  cursor: pointer;
  width: 100%;
}

.error {
  display: inline-block;
  font-size: 13px;
  color: #b0191a;
  width: 100%;
  margin-left: -20px;
}
.text-align-center {
  color: rgb(100, 95, 95);
  font-size: 14px;
}

.access {
  color: #fff;
  width: 35%;
  margin-top: 15px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
  text-decoration: none;
}
.access-center {
  text-align: center;
}

@media only screen and (max-width: 900px) {
  .text-join {
    color: rgb(100, 95, 95);
    font-size: 20px;
    margin-left: 17% !important;
  }

  label {
    display: inline-block;
    margin-left: 33px;
    font-size: 17px;
    color: rgb(100, 95, 95);
  }
  .text-align-center {
    margin-top: 5px;
    margin-left: 33px;
    color: rgb(100, 95, 95);
    font-size: 14px;
  }
  .edit-input {
    width: 80%;
    margin-left: 30px;
  }

  .modal {
    padding: 0px !important;
  }
}
@media only screen and (min-width: 960px) {
  /* styles for browsers larger than 960px; */
  .modal-dialog {
    margin-top: 4%;
  }
}
@media only screen and (min-width: 1440px) {
  /* styles for browsers larger than 1440px; */
  .modal-dialog {
    margin-top: 7%;
  }
}
@media only screen and (max-device-width: 480px) {
  /* styles for mobile browsers smaller than 480px; (iPhone) */
  .modal-dialog {
    margin-top: 20%;
  }
}
@media only screen and (device-width: 768px) {
  /* default iPad screens */
  .modal-dialog {
    margin-top: 30%;
  }
}

@media only screen and (min-width: 2000px) {
  .modal-dialog {
    margin-top: 12%;
  }
  /* for sumo sized (mac) screens */
}
/* different techniques for iPad screening */
@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* For portrait layouts only */
  .modal-dialog {
    margin-top: 35%;
  }
}

@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
  /* For landscape layouts only */
  .modal-dialog {
    margin-top: 35%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/user/read/ReadModalUser.vue